import React, {
  createContext,
  useRef,
  MutableRefObject,
  useState,
  useEffect,
  ReactNode
} from 'react';
import { useSelector } from 'react-redux';

// import { UseHighlight } from "../../../common/hooks/useHighlight";
import { workflowIdSelector } from '../../../store/task/taskSelector';
import { Shelf } from '../../../common/types';

export interface ShelfContext {
  shelf: Shelf;
  workflowId: string;
  // shelfHighlights: UseHighlight;
  setNewCommentQuillElement(ref: any): void;
  newCommentQuillElement: any | undefined;
  expandComments(shelfId: string): void;
  toggleCommentsExpanded(): void;
  isCommentsExpanded: boolean;
}

interface Props {
  shelf: Shelf;
  children: ReactNode | ReactNode[];
}

const ShelfStore = createContext({} as ShelfContext);

// TODO remove temporary solution for tracking expanded Shelves. Think of some shared parent component to hold this value, for the sake of better testability and cleaner code
let expandedShelfId: string = '';

const ShelfProvider = ({ children, shelf }: Props) => {
  const workflowId = useSelector(workflowIdSelector);
  // const shelfHighlights = useHighlight(shelf.id);

  const newCommentQuillElement: MutableRefObject<any | undefined> = useRef();
  const [isCommentsExpanded, setIsCommentsExpanded] = useState<boolean>(false);

  /* eslint-disable */
  useEffect(() => {
    return () => {
      expandedShelfId = '';
    };
  }, []);

  useEffect(() => {
    setIsCommentsExpanded(expandedShelfId === shelf.id);
  }, [expandedShelfId]);
  /* eslint-disable */

  const expandComments = (shelfId: string): void => {
    expandedShelfId = shelfId;
  };

  const toggleCommentsExpanded = (): void => {
    expandedShelfId = shelf.id === expandedShelfId ? '' : shelf.id;

    // shelfHighlights.setIsHighlightOpen(false);
    // shelfHighlights.removeHighlight();
  };

  const setNewCommentQuillElement = (ref: HTMLElement) => {
    newCommentQuillElement.current = ref;
  };

  return (
    <ShelfStore.Provider
      value={{
        shelf,
        // shelfHighlights,
        newCommentQuillElement,
        setNewCommentQuillElement,
        expandComments,
        toggleCommentsExpanded,
        isCommentsExpanded,
        workflowId
      }}
    >
      {children}
    </ShelfStore.Provider>
  );
};

export { ShelfStore, ShelfProvider };
